import React, { useEffect } from "react";
import { useGetSectorsVotesSpreadQuery } from "../../../../redux/service/modules/dashboard";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useSelector } from "react-redux";

const AnalystVotesSpread = ({ appliedFilters, setRequiredFilters }) => {
    const dateRange = useSelector((state) => state.date);
    useEffect(() => {
        setRequiredFilters(['tiers', 'clients', 'sector'])
    }, [])

    return (
        <div className="overflow-auto">
            <PaginatedDataTable
                queryHook={useGetSectorsVotesSpreadQuery}
                initialDateRange={dateRange}
                totalText="All Report Total"
                firstColumnWidth="100px"
                isColumnSticky={true}
                stickyColumnsCount={2}
                appliedFilters={appliedFilters}
            />
        </div>
    );
};

export default AnalystVotesSpread;
